import { Provider, inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import type VideoStore from './store';

import type { WithStyles } from '@material-ui/core';
import { Fab, Tooltip, withStyles } from '@material-ui/core';
import { Videocam } from '@material-ui/icons';
import { VideocamOff } from '@material-ui/icons';
import { Mic } from '@material-ui/icons';
import { MicOff } from '@material-ui/icons';
import { CallEnd } from '@material-ui/icons';
import { Fullscreen as FullscreenIcon } from '@material-ui/icons';
import { FullscreenExit as FullscreenExitIcon } from '@material-ui/icons';
import { playbackStyles } from './styles';

interface IProps extends WithStyles<typeof playbackStyles> {
  videoStore: VideoStore;
}
@inject('videoStore')
@observer
class PlaybackControls extends Component<IProps> {
  render() {
    const {
      isVideoEnabled,
      isAudioEnabled,
      toggleVideoEnabled,
      toggleAudioEnabled,
      hangUp,
      toggleFullScreen,
      isFullScreen
    } = this.props.videoStore;

    const { controls, red } = this.props.classes;
    var iOS = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && !window.MSStream;

    return (
      <div className={controls}>
        <div />
        <Tooltip
          title={isVideoEnabled ? 'Hide Video' : 'Show Video'}
          placement="top"
          PopperProps={{ disablePortal: true }}
        >
          <Fab size="small" onClick={toggleVideoEnabled} className={isVideoEnabled ? '' : red}>
            {isVideoEnabled ? <Videocam /> : <VideocamOff />}
          </Fab>
        </Tooltip>
        <Tooltip
          title={isAudioEnabled ? 'Mute Audio' : 'Unmute Audio'}
          placement="top"
          PopperProps={{ disablePortal: true }}
        >
          <Fab size="small" onClick={toggleAudioEnabled} className={isAudioEnabled ? '' : red}>
            {isAudioEnabled ? <Mic /> : <MicOff />}{' '}
          </Fab>
        </Tooltip>
        {!(isFullScreen && iOS) && (
          <Tooltip
            title={isFullScreen ? 'Exit Full Screen Mode' : 'Launch Full Screen Mode'}
            placement="top"
            PopperProps={{ disablePortal: true }}
          >
            <Fab size="small" onClick={toggleFullScreen}>
              {isFullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
            </Fab>
          </Tooltip>
        )}

        <Tooltip title={'End Call'} placement="top" PopperProps={{ disablePortal: true }}>
          <Fab size="small" onClick={hangUp} className={red}>
            <CallEnd />
          </Fab>
        </Tooltip>
      </div>
    );
  }

  componentWillUnmount() {
    this.props.videoStore.hangUp();
  }
}

export default withStyles(playbackStyles)(PlaybackControls);
